import { ulid } from 'ulid';
import type { CreateLimitInput, UpdateLimitInput } from '@/graphql/generated';
import type { LimitFormSubmitData } from './limit-form';

export type { LimitFormSubmitData };

export const buildCreateLimitInput = (
	formData: LimitFormSubmitData,
	idempotentLimitId: string
): CreateLimitInput => {
	return {
		limitId: idempotentLimitId,
		name: formData.name,
		minAmount: formData.minAmount ?? null,
		maxAmount: formData.maxAmount ?? null,
		minStayMinutes: formData.minStayMinutes ?? null,
		maxStayMinutes: formData.maxStayMinutes ?? null
	};
};

export const buildUpdateLimitInput = (
	formData: LimitFormSubmitData,
	limitId: string
): UpdateLimitInput => {
	return {
		limitId,
		name: formData.name,
		minAmount: formData.minAmount ?? null,
		maxAmount: formData.maxAmount ?? null,
		minStayMinutes: formData.minStayMinutes ?? null,
		maxStayMinutes: formData.maxStayMinutes ?? null
	};
};

export const generateIdempotentLimitId = (): string => {
	return ulid();
};
